__turbopack_context__.v({
  "bars": "knowledge-map-module__xzIVVa__bars",
  "body": "knowledge-map-module__xzIVVa__body",
  "chip": "knowledge-map-module__xzIVVa__chip",
  "close": "knowledge-map-module__xzIVVa__close",
  "cta": "knowledge-map-module__xzIVVa__cta",
  "dots": "knowledge-map-module__xzIVVa__dots",
  "drawer": "knowledge-map-module__xzIVVa__drawer",
  "empty": "knowledge-map-module__xzIVVa__empty",
  "fadeIn": "knowledge-map-module__xzIVVa__fadeIn",
  "glyph": "knowledge-map-module__xzIVVa__glyph",
  "halo": "knowledge-map-module__xzIVVa__halo",
  "haloIn": "knowledge-map-module__xzIVVa__haloIn",
  "head": "knowledge-map-module__xzIVVa__head",
  "insetIn": "knowledge-map-module__xzIVVa__insetIn",
  "layerRow": "knowledge-map-module__xzIVVa__layerRow",
  "mode": "knowledge-map-module__xzIVVa__mode",
  "modeButton": "knowledge-map-module__xzIVVa__modeButton",
  "modeThumb": "knowledge-map-module__xzIVVa__modeThumb",
  "nextText": "knowledge-map-module__xzIVVa__nextText",
  "pulse": "knowledge-map-module__xzIVVa__pulse",
  "related": "knowledge-map-module__xzIVVa__related",
  "relatedIcon": "knowledge-map-module__xzIVVa__relatedIcon",
  "relight": "knowledge-map-module__xzIVVa__relight",
  "root": "knowledge-map-module__xzIVVa__root",
  "row": "knowledge-map-module__xzIVVa__row",
  "rowChevron": "knowledge-map-module__xzIVVa__rowChevron",
  "rowIcon": "knowledge-map-module__xzIVVa__rowIcon",
  "rowLabel": "knowledge-map-module__xzIVVa__rowLabel",
  "rowVeil": "knowledge-map-module__xzIVVa__rowVeil",
  "rule": "knowledge-map-module__xzIVVa__rule",
  "showAll": "knowledge-map-module__xzIVVa__showAll",
  "slide": "knowledge-map-module__xzIVVa__slide",
  "sonar": "knowledge-map-module__xzIVVa__sonar",
  "summary": "knowledge-map-module__xzIVVa__summary",
  "switch": "knowledge-map-module__xzIVVa__switch",
  "switchCover": "knowledge-map-module__xzIVVa__switchCover",
  "title": "knowledge-map-module__xzIVVa__title",
});
